import {
  DropdownMultiSelectList,
  getMultiSelectText,
  Option
} from '@components/common/dropdown-list/dropdown-list'
import {TextInput} from '@components/common/text-input/text-input'
import {Remove, Separator} from '@components/statistics/stats-reports/common'
import React from 'react'
import {Lang} from 'yougile-lang'
import {ReportTextFilter, ReportTextFilterPlace} from 'yougile-model'

interface OuterProps {
  filter: ReportTextFilter
}

interface Props extends OuterProps {
  update: (filters: ReportTextFilter) => void
}

const getOptions = (): Option<ReportTextFilterPlace>[] => {
  const msg = Lang.msg.component.textFilter
  return [
    {value: 'task-title', label: msg.taskTitle},
    {value: 'column-title', label: msg.columnTitle},
    {value: 'board-title', label: msg.boardTitle},
    {value: 'project-title', label: msg.projectTitle},
    {value: 'task-description', label: msg.taskDescription},
    {value: 'checklists', label: msg.checklists},
    {value: 'filenames', label: msg.filenames},
    {value: 'messages', label: msg.messages}
  ]
}

export const TextFilter = (props: Props) => {
  const options = getOptions()
  const {filter = {places: options.map(x => x.value), text: ''}, update} = props

  return (
    <div className="flex justify-between">
      <div className="flex">
        <DropdownMultiSelectList
          initialOpen={!props.filter}
          className="w-176"
          onChange={places => update({...filter, places})}
          value={filter.places}
          options={options}
        />
        <Separator />
        <TextInput
          className="w-256"
          placeholder={Lang.msg.component.textFilter.placeholder}
          value={filter.text}
          onChange={text => update({...filter, text})}
        />
      </div>
      <Remove update={update} />
    </div>
  )
}

export const TextFilterValue = (props: OuterProps) => {
  const options = getOptions()
  const {filter = {places: options.map(x => x.value), text: ''}} = props

  return (
    <div>
      {getMultiSelectText({value: filter.places, options})}
      {filter.text.length > 0 && <Separator />}
      {filter.text}
    </div>
  )
}
